import React, { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import TopBar from "./scenes/global/Top-Bar";
// import Login from "./scenes/login";
// import HireLogin from "./scenes/hireLogin";
// import HireRegister from "./scenes/hireRegister";
// import Sidebar from "./scenes/global/Sidebar";
// import Welcome from "./scenes/welcome";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";

// import mypdf from it's file
import StripeComponent from "./Payment/StripeContainer";
import UploadModal from "./components/UploadModal";
import "react-toastify/dist/ReactToastify.css";
// protected route component
import ProtectedRoute from "./scenes/protectedRoute";
import LoaderModal from "./components/LoaderModal";

import Home from "./scenes/home";
import HomeDashboard from "./scenes/Dashboard";
// import Resume from "./scenes/MyResume/Resume";
// import UserDashboard from "./scenes/Dashboard/UserDashboard";
// import AuthPage from "./scenes/authPage";
// import Forgot from "./scenes/authPage/Forgot";
// import Reset from "./scenes/authPage/Reset";
// import Logout from "./scenes/Logout/logout";
import UserResumeForm from "./Resume/moil_user_resume";
import UserResume from "./Resume/screens/moil_user_resume";
import { useSelector, useDispatch } from "react-redux";
import UserResumeType from "./Resume/screens/moil_user_resume_type";
import WorkerProfile from "./scenes/Dashboard/newProfile";
import UserPreviewDetails from "./Resume/screens/moil_user_preview";
import UserJobType from "./Resume/screens/moil_user_job_type";
import UserSKillsAndLicensing from "./Resume/screens/moil_user_license";
import UserEducation from "./Resume/screens/moil_user_education";
import UserWorkExperience from "./Resume/screens/moil_user_work";
import UserReference from "./Resume/screens/moil_user_reference";
// imports from BigSam
 import EmployerProfile from "./scenes/Dashboard/EmployerProfile/EmployerProfile.jsx";
 import EmployerForm from "./scenes/Dashboard/EmployerProfile/EmployerForm";
 import EmployerProfilePhoto from './scenes/Dashboard/EmployerProfile/EmployerProfilePhoto';
//  import ShareProfile from "./scenes/Dashboard/shareProfile";
 import EmployerProfileView from "./scenes/Dashboard/worker_employerView_profile";
 import ProfileProtected from "./profileProtected";

// const EmployerProfile = lazy(() => import("./scenes/Dashboard/EmployerProfile/EmployerProfile.jsx"))
// const EmployerForm = lazy(() => import("./scenes/Dashboard/EmployerProfile/EmployerForm"))
// const EmployerProfilePhoto = lazy(() => import("./scenes/Dashboard/EmployerProfile/EmployerProfilePhoto"))
const ShareProfile = lazy(() => import("./scenes/Dashboard/shareProfile"))
// const EmployerProfileView = lazy(() => import("./scenes/Dashboard/worker_employerView_profile"))
// const ProfileProtected = lazy(() => import("./profileProtected"))

const Register = lazy(() => import("./scenes/Register"))
const Login = lazy(() => import("./scenes/login"))
const HireLogin = lazy(() => import("./scenes/hireLogin"))
const HireRegister = lazy(() => import("./scenes/hireRegister"))
const Sidebar = lazy(() => import("./scenes/global/Sidebar"));
const Welcome = lazy(() => import("./scenes/welcome"));
const Resume = lazy(() => import("./scenes/MyResume/Resume"));
const UserDashboard = lazy(() => import("./scenes/Dashboard/UserDashboard"));
const AuthPage = lazy(() => import("./scenes/authPage"));
const Forgot = lazy(() => import("./scenes/authPage/Forgot"));
const Reset = lazy(() => import("./scenes/authPage/Reset"));
const Logout = lazy(() => import("./scenes/Logout/logout"));
// const UserResumeForm = lazy(() => import("./Resume/moil_user_resume"));
// const WorkerProfile = lazy(() => import("./scenes/Dashboard/newProfile"));
// const UserPreviewDetails = lazy(() => import("./Resume/screens/moil_user_preview"));
// const UserJobType = lazy(() => import("./Resume/screens/moil_user_job_type"));
// const UserSKillsAndLicensing = lazy(() => import("./Resume/screens/moil_user_license"));
// const UserEducation = lazy(() => import("./Resume/screens/moil_user_education"));
// const UserWorkExperience = lazy(() => import("./Resume/screens/moil_user_work"));
// const UserReference = lazy(() => import("./Resume/screens/moil_user_reference"));
// const UserResumeType = lazy(() => import("./Resume/screens/moil_user_resume_type"));
// const UserResume = lazy(() => import("./Resume/screens/moil_user_resume"));

function App() {
  const profile_state = useSelector((prev) => prev.login);
  const userInfo = useSelector(e => e.userInfo);
  const [theme, colorMode] = useMode();
  const [p_stat, setP_stat] = useState();
  useEffect(() => {
    if (profile_state.profile_status === false) {
      setP_stat("no resume");
    } else if (profile_state.profile_status === true) {
      setP_stat("resume");
    }
  }, [profile_state.profile_status]);

  const [isSidebar, setIsSidebar] = useState(true);
  const [bool, setBool] = useState(false);
  const location = useLocation();
  const hideSidebarRoutes = [
    "/login",
    "/register",
    "/hireregister",
    "/hirelogin",
    "/welcome",
    "/user",
    "/",
    "/home",
    "/auth/forgot",
    "/auth/reset",
    "/analytics",
    "/generateCV",
    "/create",
  ];
  // const shouldShowSidebar = !hideSidebarRoutes.includes(location.pathname);
  const shouldShowSidebar = !hideSidebarRoutes.some((x) =>
    location.pathname.includes(x.slice(1))
  );

  console.log("bool", bool);
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {shouldShowSidebar ||
            (location === "/form" && <Sidebar isSidebar={isSidebar} />)}
          <main className="content">
            {shouldShowSidebar && <TopBar setIsSidebar={setIsSidebar} />}

            {/* {bool === true ? <TopBar /> : null} */}
            <Suspense fallback={<LoaderModal text="Our AI is loading your data" />}>
            <Routes>
              <Route path="/" element={
                  <Home />
              } />
              <Route path="/profile/beta/*" element={
                <ProfileProtected>
                  <EmployerProfileView />
                </ProfileProtected>
              }
              />
              <Route path="/home" element={<Home />} />
              <Route path="/user" element={
                <ProtectedRoute>
                  <HomeDashboard />
                </ProtectedRoute>
              }>
                <Route
                  path="profile/:profile_id"
                  element={
                    <ProtectedRoute>
                      <WorkerProfile />
                    </ProtectedRoute>
                  }
                />
                {/* New path added by BigSam  */}
                <Route
                  path="employer/form/*"
                  element={
                    <ProtectedRoute>
                      <EmployerForm />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="update/profilephoto"
                  element={
                    <ProtectedRoute>
                      <EmployerProfilePhoto />
                    </ProtectedRoute>
                  }
                />
				
                <Route
                  path="employer/profile"
                  element={
                    <ProtectedRoute>
                      <EmployerProfile />
                    </ProtectedRoute>
                  }
                />
                <Route path="dashboard" element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              } />
              <Route
                  path=":profile_id/share"
                  element={
                    <ProtectedRoute>
                      <ShareProfile />
                    </ProtectedRoute>
                  } />
                <Route path="logout" element={
                  <ProtectedRoute>
                    <Logout />
                  </ProtectedRoute>
                } />
              </Route>

              <Route path="user/dashboard1" element={
                <ProtectedRoute>
                  <UserResume />
                </ProtectedRoute>
              } />

              <Route
                path="user/profile/update/about"
                element={
                  <ProtectedRoute>
                    <UserJobType />
                  </ProtectedRoute>
                }
              />

              <Route
                path="user/profile/update/skills"
                element={
                  <ProtectedRoute>
                    <UserSKillsAndLicensing />
                  </ProtectedRoute>
                }
              />

              <Route
                path="user/profile/update/education"
                element={
                  <ProtectedRoute>
                    <UserEducation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="user/profile/update/experience"
                element={
                  <ProtectedRoute>
                    <UserWorkExperience />
                  </ProtectedRoute>
                }
              />
              <Route
                path="user/profile/update/reference"
                element={
                  <ProtectedRoute>
                    <UserReference />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/resume"
                element={
                  <ProtectedRoute>
                    <Resume />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/welcome" 
                element={
                  <Welcome />
                } 
              />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/authenticate" element={<AuthPage />}>
                <Route path="forgot" index element={<Forgot />} />
                <Route path="reset" element={<Reset />} />
              </Route>
              <Route path="/hirelogin" element={<HireLogin />} />
              <Route path="/hireregister" element={<HireRegister />} />
              <Route
                path="/generateCV"
                element={
                  <ProtectedRoute>
                    <UserResumeType />
                  </ProtectedRoute>
                }
              />
              <Route path="/allCv" element={
                <ProtectedRoute>
                  <UserPreviewDetails />
                </ProtectedRoute>
              } />
              <Route
                path="/payment"
                element={
                  <ProtectedRoute>
                    <StripeComponent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upload"
                element={
                  <ProtectedRoute>
                    <UploadModal />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/resume/:cvID"
                element={
                  <ProtectedRoute>
                    <UserPreviewDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/form/:id/*"
                element={
                  <ProtectedRoute>
                    <UserResumeForm />
                  </ProtectedRoute>
                }
              />
            </Routes>
            </Suspense>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
